import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { SupportServiceCategoryWithServices } from '@src/api/types/supportService';

export type ContactFormDefaults = {
  company_name: string;
  company_name_kana: string;
  department: string;
  position: string;
  name: string;
  name_kana: string;
  email: string;
};

export type ContactFormShowResponse = {
  contact_id: number;
  support_service_categories: SupportServiceCategoryWithServices[];
  defaults: ContactFormDefaults | null;
};

export type ContactFormShowParams = {
  inflowRoute: number;
  supportServiceId?: number;
};

export const contactFormApiClient = {
  show: async (params: ContactFormShowParams): Promise<ApiResult<ContactFormShowResponse>> => {
    return await axiosClient.get('/company/contacts/form', {
      params: {
        inflow_route: params.inflowRoute,
        support_service_id: params.supportServiceId,
      },
    });
  },
};
